define('dashboard-controller',[], function() {
  var app = angular.module('dashboard.controller', ['dashboard.resource']);
  app.controller('DashboardController', ['$scope', 'Dashboard',  function($scope, Dashboard) {
    $scope.regioesList = [];
    $scope.imobl_codigo = 1;

    $scope.loaded = true;

  }]);
});

